import _ from "lodash";
import { msalInstance } from "../core/authentication/entra/msal";

//this function manages session token
export async function validateOktaSession(props?: any) {
  let oktaToken: any = localStorage.getObj("okta-token-storage");
  if (oktaToken && _.isEmpty(oktaToken)) {
    sessionStorage.setItem("login-session-expired", "true");
  }
}

//this function manages session token
export function validateAdminOktaSession(
  props: any,
  opts: { isError?: boolean; forceLogout?: boolean } = {}
) {
  const isAdmin = window.location.pathname.startsWith("/admin");

  // --- Admin area: use MSAL/Entra flow ---
  if (isAdmin) {
    const instance = msalInstance;
    const accounts = instance.getAllAccounts();

    // Only ever logout if we *explicitly* request it
    if (opts.forceLogout) {
      return instance.logoutRedirect({
        postLogoutRedirectUri: `${window.location.origin}/admin`,
      });
    }

    // If not signed in, start MSAL login – don't logout
    if (accounts.length === 0) {
      // Remember where to land after login
      sessionStorage.setItem("msal.redirectStartPage", "/admin/testlist");

      return instance.loginRedirect({
        scopes: ["openid", "profile", "email"],
      });
    }

    return;
  }

  // --- Consumer site: keep Okta behavior as before ---
  // If the consumer session is bad, sign out via Okta to cleanly reset
  const oktaToken = sessionStorage.getItem("okta-token-storage");
  const isError = !!opts.isError;

  if ((oktaToken && _.isEmpty(oktaToken)) || isError === true) {
    sessionStorage.setItem("isAdminSessionExpired", "true");
    if (props?.oktaAuth?.signOut) {
      return props.oktaAuth.signOut({
        postLogoutRedirectUri: `${window.location.origin}/`,
      });
    }
  }
}